import { useApp } from "../../context/formflow/AppContext";

export function Toast() {
  const { toast } = useApp();
  if (!toast) return null;
  const clr = { success: "#10b981", error: "#ef4444", info: "#3b82f6" }[toast.type] || "#3b82f6";
  return (
    <div
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 9999,
        background: "white",
        borderRadius: 12,
        padding: "14px 20px",
        boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
        borderLeft: `4px solid ${clr}`,
        display: "flex",
        alignItems: "center",
        gap: 12,
        animation: "slideUp 0.3s ease",
        maxWidth: 360,
      }}
    >
      <div style={{ width: 8, height: 8, borderRadius: "50%", background: clr, flexShrink: 0 }} />
      <span style={{ fontSize: 14, color: "#1f2937", fontWeight: 500 }}>{toast.msg}</span>
    </div>
  );
}
